class CartPage extends HTMLElement {
  constructor() {
    super();

    this.simBtn = this.querySelectorAll('[data-cart-sim-btn]');
    this.simBtn.forEach((btn) => {
      btn.addEventListener('click', this.handleSimBtnClick.bind(this));
    });

    // Reload page on cart update
    document.body.addEventListener('cart:updated', () => {
      location.reload();
    });
  }

  handleSimBtnClick(e) {
    e.preventDefault();
    document.body.dispatchEvent(new CustomEvent('open-dialog:sim'));
  }
}
customElements.define('cart-page', CartPage);
